var msg: Translations = {
    'msg.form.invalidemail':'Ungültige oder fehlende E-Mail',
    'msg.form.invalidrecipients':'Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an die Verwaltung und melden Sie den folgenden Fehler: "Kontaktempfänger ungültig oder abwesend."',
    'msg.form.invalidtype':'Es ist ein Fehler aufgetreten. Bitte kontaktieren Sie die Verwaltung und melden Sie den folgenden Fehler: "Kontaktart ungültig oder abwesend."',
    DELETEALLPRODUCTSERROR: 'Error removing products from cart',
    ERR_CARRIERMISSING: 'Sie müssen eine Versandart zuerst wählen.',
    ERR_CARRIER_COST_MISSING: 'No fee available for selected country carrier and order weight',
    ERR_CLIENTMANDATORYFIELDS: 'Füllen Sie alle Pflichtfelder.',
    ERR_DATE_FROM: "Date must be after :from",
    ERR_DATE_FROM_TO: "Date must be between :from and :to",
    ERR_DATE_TO: "Date must be before :to",
    ERR_FILE_TOO_LARGE: "Die Datei ist zu groß (max. Größe: :size)",
    ERR_FILLEMAILFIELD: 'Füllen Sie das E-Mail-Feld',
    ERR_INVALIDMAIL: 'Ungültige E-Mail-Adresse.',
    ERR_LIGHTBOX_LOADING: 'Image detail is loading, try again in a few seconds',
    ERR_LOGININVALID: 'Ungültige E-Mail oder Passwort',
    ERR_LOGINREQUIRED: 'Login erforderlich',
    ERR_MISSINGFIELDS: 'Füllen Sie alle Felder aus.',
    ERR_NOSIZESELECTED: 'Sie müssen eine Größe auswählen',
    ERR_PEC_OR_SDI: 'Fill in at least one of PEC and SDI',
    ERR_PHONE_FORMAT_GENERIC: "Ungültige Telefonnummer",
    ERR_PHONE_FORMAT_INVALID_COUNTRY: "Ungültiges Land",
    ERR_PHONE_FORMAT_NOT_A_NUMBER: "Kann nur numerische Zeichen enthalten",
    ERR_PHONE_FORMAT_TOO_LONG: "Rufnummer zu lang",
    ERR_PHONE_FORMAT_TOO_SHORT: "Telefonnummer zu kurz",
    ERR_PRIVACY: 'Um fortzufahren, müssen Sie die Bedingungen akzeptieren.',
    ERR_USEREXISTS: 'User existiert.',
    ERR_VAT: 'Incorrect VAT format',
    ERR_VAT_PREFIX: 'VAT must begin with country code (e.g. IT, FR)',
    ERR_ZIP_FORMAT: "",
    LABEL_ALREADYREGISTEREDUSERES: 'Already registered users',
    LABEL_ARTICLES: 'produkte',
    LABEL_CANCEL: 'Cancel',
    LABEL_CONFIRM: 'Confirm',
    LABEL_INVITES_ALREADY_SENT: 'Users already invited',
    LABEL_NOTAPPLICABLE: 'Nicht anwendbar',
    LABEL_NOTSENTINVITES: 'Unsent invites',
    LABEL_SELECTALL: 'Select all',
    LABEL_SENTINVITES: 'Sent invites',
    LABEL_SUBMIT: 'Submit',
    LABEL_WARNING: 'Warning',
    MSG_ADDEDTOCART: 'Produkte in den Korb einfügen',
    MSG_ADDED_TO_WISHLIST: 'Produkt auf Ihrer Wunschliste hinzugefügt',
    MSG_APPLIEDVATCHANGED: 'After billing data upgrade, VAT applied to your order changed. Check the new amount ones page gets reloaded.',
    MSG_COUPON_ERROR: 'The coupon code inserted is not valid or has been already burned',
    MSG_COUPON_VALID: 'The coupon code inserted has been accepted successfully',
    MSG_DEFERRED_DISPATCH_COMPUTATION: 'Nur um Reservierung Modus wird aktiviert und Versandgebühren werden Sie per E-Mail gesendet.',
    MSG_DELETEALLPRODUCTS: 'Are you sure you want to remove all products from the cart?',
    MSG_EXTRAUELIMIT: 'Der Mindestbetrag soll nicht niedriger als 2000.00 &euro, sein ',
    MSG_GENERIC_ERROR: 'Leider ist ein Fehler aufgetreten.',
    MSG_INSUFFICIENT_STOCK: 'Entschuldigung, im Moment haben wir nicht genug Verfügbarkeit der Produkte.',
    MSG_INVALID_CAPTCHA: 'Invalid captcha code',
    MSG_MAILSENT: 'E-Mail gesendet',
    MSG_MESSAGE_PRODUCTSHARE: 'Nachricht',
    MSG_CONTACT_SENT: 'Message sent successfully!',
    MSG_MESSAGE_SENT: 'Message sent successfully!',
    MSG_MIXED_CART: 'Dieses Produkt kann nicht zusammen mit Produkten in Ihrem Warenkorb gekauft werden, weil es in ein anderem Lager ist',
    MSG_MIXED_INTANGIBLE: 'Dieses Produkt kann nicht zusammen mit Produkten gekauft werden Sie bereits in Ihrem Warenkorb.',
    MSG_MUST_ACCEPT_TERMS: 'You must accept the terms of use',
    MSG_NEWSLETTER_COMPLETED: 'Successful registration',
    MSG_PASSWORD_NOT_COMPLEX: 'Password must include at least 1 uppercase character, 1 lowercase character and 1 number and be at least 8 characters long',
    MSG_PASSWORD_NOT_EQUAL: 'Das neue Passwort und das Bestätigungspasswort stimmen nicht überein',
    MSG_PASSWORD_OK: 'Das Passwort wurde erfolgreich geändert',
    MSG_PASSWORD_RESET: 'Password was succesfully reset',
    MSG_PAYMENT_PENDING: 'Ausstehende Zahlung',
    MSG_PRIVACY_POLICY: 'You must accept the privacy policy',
    MSG_PROFILECONSENT_SAVED: 'Wir haben ihre Kontaktvoreinstellungen aktualisiert',
    MSG_RECOVEREMAILSENT: 'Überprüfen Sie Ihre E-Mail und klicken Sie auf dem Link, um die Änderung zu bestätigen.',
    MSG_RECOVEREMAILSENT_ERROR: 'Achtung: Sie sind mit dieser E-Mail-Adresse nicht angemeldet oder Sie setzen Ihr Passwort bereits zurück.',
    MSG_REMOVED_FROM_WISHLIST: 'Product removed from your wishlist',
    MSG_RETURN_REQUEST: 'Return request created successfully',
    MSG_RETURN_REQUEST_ERROR: 'Return request could not be created, contact the admin',
    MSG_RETURN_REQUEST_SUCCESS: 'Return Request created successfully',
    MSG_RULE_REJECT: 'Product cannot be added to cart because of rule :rule',
    MSG_SAVE_SUCCESS: 'Save successful',
    MSG_SELECT_PROVINCE: "Select a province",
    MSG_SENDER_PRODUCTSHARE: 'Ihr Name',
    MSG_SUBJECT_PRODUCTSHARE: ' etwas mit Ihnen geteilt',
    MSG_SUBSCRIBED: 'Erfolgreich registriert',
    MSG_SUBSCRIPTION_FAILURE: 'Make sure you do not have any other active subscription',
    MSG_SUBSCRIPTION_NO_RENEWABLE: 'Es sind zu viele Tage vergangen, so dass das Abonnement nicht mehr verlängert werden kann',
    MSG_TOKEN_SENT: 'We have sent a verification code to your e-mail address. Check that you have received our message and input the code',
    MSG_USER_ALREADY_REGISTERED: 'User is already registered',
    MSG_USER_NOT_FOUND: 'User not found',
    MSG_WAIT: 'Warten Sie bitte ...',
    MSG_WRONG_PASSWORD: 'Wrong password'
}